import { render, staticRenderFns } from "./PageSize.vue?vue&type=template&id=4a0904e7"
import script from "./PageSize.vue?vue&type=script&lang=js"
export * from "./PageSize.vue?vue&type=script&lang=js"
import style0 from "./PageSize.vue?vue&type=style&index=0&id=4a0904e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports